import { Institution } from '../../../types/Institution';
import { ApiInstitution } from '../queries/dtos/ApiInstitution';

export function institutionsAdapter(institution: ApiInstitution): Institution {
  return {
    label: institution.name,
    value: institution.external_id
  };
}
